import { inject } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { CanActivateFn, Router, UrlTree } from '@angular/router'

import { Observable, filter, map, take } from 'rxjs'

import { ApplicationPermissionsStore } from '@flowx/designer/modules/projects/store/application-permissions.store'

import { AssetPermissionValue } from '../entities/application.entity'

export function DefaultApplicationPermissionsGuard(
  permission: AssetPermissionValue
): CanActivateFn {
  return (): Observable<boolean | UrlTree> => {
    const router = inject(Router)
    const applicationPermissionsStore = inject(ApplicationPermissionsStore)

    // TODO return a signal once Angular supports it
    return toObservable(applicationPermissionsStore.permissions).pipe(
      filter(Boolean),
      take(1),
      map((permissions) => {
        const isPermitted = permissions[permission]
        return isPermitted ? true : router.parseUrl('/403')
      })
    )
  }
}
